// extracted by mini-css-extract-plugin
export var banner = "_t7-0";
export var settingRow = "_t7-2";
export var titleIcon = "_t7-1";